import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUpdateCarePlanMedicalNote } from '../types';

const onUpdateCarePlanMedicalNote: IThunkUpdateCarePlanMedicalNote = thunk(
  // @ts-ignore
  async ({ updateCarePlanMedicalNote }, payload) => {
    const { data } = await api.carePlanMedicalNotes.update(payload);
    updateCarePlanMedicalNote(data);
  },
);

export default onUpdateCarePlanMedicalNote;
